import { render } from "./MoxeyIcon.vue?vue&type=template&id=c60bc1a0"
import script from "./MoxeyIcon.vue?vue&type=script&lang=js"
export * from "./MoxeyIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__